import { render, staticRenderFns } from "./view-consent-detail.vue?vue&type=template&id=73cd92be&scoped=true&"
import script from "./view-consent-detail.vue?vue&type=script&lang=js&"
export * from "./view-consent-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd92be",
  null
  
)

export default component.exports